import { enrollmentMessages } from '../common/enrollment-messages.mjs'
import { assessmentMessages } from '../common/assessment-messages.mjs'
import { taskMessages } from '../common/task-messages.mjs'
import { surveyMessages } from '../common/survey-messages.mjs'
import { completionMessages } from '../common/completion-messages.mjs'
import { managerCompletionMessages } from './manager-completion.mjs'
import { motpMessages } from '../common/motp-messages.mjs'
import { certificateMessages } from '../common/certificate-messages.mjs'
const messages = {
  ...managerCompletionMessages,
  B2B_ASSESSMENT_DENIED: '현재 평가 조회 권한이 없거나 조회 범위를 벗어났습니다.',
  B2B_ASSESSMENT_FILTER_INVALID: '평가 검색 조건을 확인해 주세요.',
  B2B_LEARNING_DENIED: '현재 학습 조회 권한이 없거나 조회 범위를 벗어났습니다.',
  B2B_LEARNING_FILTER_INVALID: '학습 조회 조건을 확인해 주세요.',
  ...certificateMessages,
  ...motpMessages,
  ...completionMessages,
  ...surveyMessages,
  ...taskMessages,
  ...assessmentMessages,
  ...enrollmentMessages,
  CONTRACT_EVIDENCE_UNAVAILABLE: '계약 증빙을 확인할 수 없습니다. 운영 관리자에게 문의해 주세요.',
  FILE_CONTENT_UNAVAILABLE: '계약 증빙을 읽을 수 없습니다. 운영 관리자에게 문의해 주세요.',
  INVALID_CREDENTIALS: '아이디 또는 비밀번호를 확인해 주세요.',
  INVALID_PASSWORD: '새 비밀번호는 8자 이상이며 영문을 포함해야 합니다.',
  FORBIDDEN: '이 작업을 사용할 권한이 없습니다.',
  COMPANY_SCOPE_DENIED: '이 기업의 조회 권한이 없거나 기업 소속이 종료되었습니다. 담당 기업 목록을 다시 확인해 주세요.',
  INVALID_TOKEN: '로그인이 만료되었습니다. 다시 로그인해 주세요.',
  SESSION_CHANGED: '다른 탭에서 로그인 상태가 변경되었습니다. 다시 확인해 주세요.',
  MEMBER_VERSION_CONFLICT: '회원 정보가 먼저 변경되었습니다. 입력값은 유지했습니다. 최신 정보 다시 불러오기로 현재 내용을 확인해 주세요.',
  MEMBER_BUSY: '회원 정보의 다른 변경을 처리 중입니다. 잠시 후 다시 시도해 주세요.',
  MEMBER_DATA_UNAVAILABLE: '회원 정보를 확인할 수 없습니다. 운영 담당자에게 문의해 주세요.',
  MEMBER_SELF_REQUIRED: '로그인한 회원의 정보만 확인할 수 있습니다. 다시 로그인해 주세요.',
}
export const messageOf = error => messages[error?.code] || error?.message || '요청을 처리하지 못했습니다. 다시 시도해 주세요.'
